import React from "react";

import { IStringField } from "../../models/formFields";
import { FormInputFieldWrapper } from "../FormInputFieldWrapper";
import { PasswordRevealInput } from "../PasswordRevealInput";
import { FORM_FIELD_INPUT_CLASS_NAME } from "../classNames";
import { useFormField } from "../hooks/useFormField";

export const FormPasswordInput = <T extends string>(
    props: IStringField<T>,
): React.ReactNode => {
    const { type = "password", minLength, maxLength } = props;

    const field = useFormField<T, HTMLInputElement>({
        ...props,
        type: type,
    });

    const inputProps = {
        ...field.inputProps,
        ref: field.inputRef,
        minLength,
        maxLength,
        autoComplete: "new-password",
        className: props.className ?? FORM_FIELD_INPUT_CLASS_NAME,
    };

    return (
        <FormInputFieldWrapper
            {...props}
            type={type}
            focused={field.focused}
            isRequired={field.isRequired}
            onLabelClick={field.onLabelClick}
        >
            <PasswordRevealInput inputProps={inputProps} />
        </FormInputFieldWrapper>
    );
};
